import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "no-gutters": ""
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  class: "text-center",
  style: {"cursor":"pointer"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fill: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_oss_dialog, {
        title: "Confirmation",
        modelValue: _ctx.dialogConfirmOperations,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogConfirmOperations) = $event)),
        onValid: _cache[1] || (_cache[1] = ($event: any) => {
                _ctx.createOperations();
                _ctx.dialogConfirmOperations = false;
            }),
        "max-width": "40vw"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createElementVNode("div", null, "Voulez-vous vraiment créer les opérations ?", -1)
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "mb-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "my-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_back, {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.backPath()), ["stop"]))
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" Opérations de stock associées ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_divider)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      true
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(_component_v_card, {
                              class: "default_card_wm mx-auto py-2 mb-2",
                              style: {"background":"#fff !important","border":"solid rgba(0, 0, 0, 0.12) 1px","box-shadow":"none"}
                            }, {
                              default: _withCtx(() => [
                                (!_ctx.$vuetify.display.mobile)
                                  ? (_openBlock(), _createBlock(_component_v_data_table, {
                                      key: 0,
                                      headers: _ctx.headers,
                                      items: _ctx.operations,
                                      class: "table elevation-0",
                                      "fixed-header": "",
                                      "max-height": "60vh",
                                      "hide-default-footer": true,
                                      density: "compact"
                                    }, {
                                      item: _withCtx((props) => [
                                        _createElementVNode("tr", {
                                          class: _normalizeClass(props.item.selected ? 'info' : '')
                                        }, [
                                          _createElementVNode("td", _hoisted_2, [
                                            _createElementVNode("span", null, _toDisplayString(props.item.title) + " - " + _toDisplayString(props.item.reference), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_3, [
                                            _createElementVNode("span", null, _toDisplayString(props.item.quantity), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_4, [
                                            _createElementVNode("span", null, _toDisplayString(props.item.price), 1)
                                          ]),
                                          _cache[10] || (_cache[10] = _createElementVNode("td", {
                                            class: "text-center",
                                            style: {"cursor":"pointer"}
                                          }, null, -1))
                                        ], 2)
                                      ]),
                                      "body.append": _withCtx(() => [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", _hoisted_5, [
                                            _createVNode(_component_v_select_filled, {
                                              "hide-details": "",
                                              style: {"pointer-events":"auto"},
                                              modelValue: _ctx.stockOperation.stockProduct,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stockOperation.stockProduct) = $event)),
                                              items: _ctx.products,
                                              "return-object": "",
                                              class: "v-select-font-size mt-2",
                                              density: "compact",
                                              "item-title": (item) => item.title
                                            }, null, 8, ["modelValue", "items", "item-title"])
                                          ]),
                                          _createElementVNode("td", _hoisted_6, [
                                            _createVNode(_component_oss_text_field_filled, {
                                              "hide-details": true,
                                              class: "ml-2 mt-2 righted-input",
                                              modelValue: _ctx.stockOperation.quantity,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.stockOperation.quantity) = $event)),
                                              rules: [
                                                            (v) =>
                                                                v > 0 ||
                                                                _ctx.$t('settings.positiveNumber'),
                                                        ]
                                            }, null, 8, ["modelValue", "rules"])
                                          ]),
                                          _createElementVNode("td", _hoisted_7, [
                                            _createVNode(_component_oss_text_field_filled, {
                                              "hide-details": true,
                                              class: "ml-2 mt-2 righted-input",
                                              modelValue: _ctx.stockOperation.price,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stockOperation.price) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("td", _hoisted_8, [
                                            _createVNode(_component_v_btn_add_icon, {
                                              size: "x-small",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addRow())),
                                              class: "mt-2",
                                              disabled: 
                                                            _ctx.stockOperation.quantity <= 0 ||
                                                            _ctx.stockOperation.price <= 0
                                                        
                                            }, null, 8, ["disabled"])
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "my-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_spacer)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "auto",
                            class: "d-flex align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogConfirmOperations = true)),
                                elevation: "0",
                                rounded: "",
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode(" Valider ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}